export default __webpack_public_path__ + "static/media/family2.3579d066.jpg";